import styled from 'styled-components';
import { desktop_breakpoint } from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import chZindex from '../../zIndex';

export const FindARetailerStyles = styled.div`
  background-color: inherit;
  margin: 72px 0 0;
  min-height: 500px;
  padding: 24px 0 48px 0;
  pointer-events: 'auto';

  .modal-window {
    z-index: ${chZindex.locationsFiltersBar};
    left: 20px;
  }
  .loading-indicator {
    background-color: ${(props) => (props.$overlay ? 'white' : 'transparent')};
    z-index: ${chZindex.loadingIndicator};
    width: 100%;
    opacity: 0.5;

    > div {
      position: relative;
      top: 100px;
    }
  }
  h3,
  .purchase-location {
    span {
      position: relative;
      top: 2px;
    }
  }
  .purchase-location a {
    text-decoration: none;
  }
  .load-more {
    margin: 48px auto 0 auto;
  }
  .no-retailers {
    pointer-events: auto;
    margin-top: 125px;

    > div {
      padding: 10px;
    }
    > p {
      padding-bottom: 23px;
    }

    .no-retailers-button {
      max-width: 200px;
      padding: 17px;
    }
  }
  .retailer-list {
    margin-top: 35px;
  }

  /* This is to fix a weird word wrapping around the 360px mark for purchase location */
  @media only screen and (min-width: 360px) and (max-width: 370px) {
    .purchase-location {
      width: 77%;
    }
  }
  @media only screen and (min-width: ${desktop_breakpoint}px) {
    margin: 96px 0 0;
    padding: 72px 0;

    .modal-window {
      left: 120px;
    }
    h3,
    .purchase-location {
      span {
        position: relative;
        top: 2px;
      }
    }
    .retailer-list {
      display: flex;
      flex-wrap: wrap;
      width: 100%;

      > div:not(.loading-indicator):not(.no-retailers) {
        width: 33%;
      }
    }
    .load-more {
      width: 145px;
    }
  }
`;
